import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiArrowRight, FiGrid } from 'react-icons/fi';
import './ServiceNav.css';

const servicesOrder = [
  { path: '/services/artificial-intelligence-intelligent-automation', name: 'AI & Intelligent Automation' },
  { path: '/services/gst-reconciliation', name: 'GST Reconciliation' },
  { path: '/services/stock-market-data-analysis', name: 'Stock Market Data Analysis' },
  { path: '/services/bank-narration-intelligence', name: 'Bank Narration Intelligence' },
  { path: '/services/dpdp-compliance', name: 'DPDP Compliance' },
  { path: '/services/call-centre-customer-service-automation', name: 'Call Centre Automation' },
  { path: '/services/digital-marketing-customer-engagement', name: 'Digital Marketing' },
  { path: '/services/automation-process-digitisation-mis', name: 'Automation & MIS' },
];

export default function ServiceNav({ currentPath }) {
  const currentIndex = servicesOrder.findIndex((s) => s.path === currentPath);
  if (currentIndex === -1) return null;

  const prevIndex = (currentIndex - 1 + servicesOrder.length) % servicesOrder.length;
  const nextIndex = (currentIndex + 1) % servicesOrder.length;

  const prevService = servicesOrder[prevIndex];
  const nextService = servicesOrder[nextIndex];

  return (
    <div className="service-nav-bar">
      <div className="service-nav-container">
        <Link to={prevService.path} className="service-nav-link prev">
          <FiArrowLeft className="nav-arrow" />
          <div className="nav-link-text">
            <span className="nav-label">PREVIOUS SERVICE</span>
            <span className="nav-title">{prevService.name}</span>
          </div>
        </Link>

        <Link to="/services" className="service-nav-all">
          <FiGrid className="all-icon" />
          <span>View PDF</span>
        </Link>

        <Link to={nextService.path} className="service-nav-link next">
          <div className="nav-link-text">
            <span className="nav-label">NEXT SERVICE</span>
            <span className="nav-title">{nextService.name}</span>
          </div>
          <FiArrowRight className="nav-arrow" />
        </Link>
      </div>
    </div>
  );
}
